import React, { useState, Fragment, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
type Category = 'gran-escala' | 'empresa' | 'hogar';
const categories: {
  id: Category;
  label: string;
  desc: string;
}[] = [{
  id: 'gran-escala',
  label: 'Proyectos a gran escala',
  desc: 'Contamos con la experiencia y el equipo para llevar a cabo construcciones de cualquier magnitud con total seguridad.'
}, {
  id: 'empresa',
  label: 'Tu empresa',
  desc: 'Oficinas, recepciones, auditorios y locales comerciales diseñados para la eficiencia operativa.'
}, {
  id: 'hogar',
  label: 'Tu hogar',
  desc: 'Reformas de alta gama y construcción de vivienda desde cero.'
}];
const projects = [{
  id: 1,
  category: 'gran-escala',
  image: 'https://images.unsplash.com/photo-1541888086425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Infraestructura Vial'
}, {
  id: 2,
  category: 'gran-escala',
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1631&q=80',
  title: 'Desarrollo Civil'
}, {
  id: 3,
  category: 'empresa',
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80',
  title: 'Oficinas Corporativas'
}, {
  id: 4,
  category: 'empresa',
  image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Espacios Comerciales'
}, {
  id: 5,
  category: 'hogar',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1475&q=80',
  title: 'Reforma Residencial Moderna'
}, {
  id: 6,
  category: 'hogar',
  image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Diseño de Interiores'
}];
const granEscalaSubcategories = [{
  id: 'puentes',
  title: 'Puentes',
  image: 'https://cdn.magicpatterns.com/uploads/pnoik2t1uik3AYNAyE3KeA/gerfaj-panamericano.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/9nPWuiEvfd5SUzDaue91AF/gerfaj_paranamericano_landing.png', 'https://cdn.magicpatterns.com/uploads/vNZKWNaBwrT3XwAazfkxAd/gerfaj_giron_landing.png', 'https://cdn.magicpatterns.com/uploads/cEAGr1PFV5as5c4M8SYnFG/gerfaj_cenfer_LANDING.png']
}, {
  id: 'iglesias',
  title: 'Iglesias',
  image: 'https://cdn.magicpatterns.com/uploads/bCcoAY7krYvPZXDBTFWrXo/GERFAJ-IGLESIA_LA_MESA.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/4yk6fQxJardYaxDEePa6dD/gerfaj_la_colina_landing.png', 'https://cdn.magicpatterns.com/uploads/82xZ8M7J6556saH5E8LyZp/gerfaj_zapamanga_landing.png', 'https://cdn.magicpatterns.com/uploads/dEb1A2QhhU6W6tHf5if6iK/GERFAJ_JEFER_LANDING.png']
}, {
  id: 'conventos',
  title: 'Conventos',
  image: 'https://cdn.magicpatterns.com/uploads/eXKSGKTesqTxbYM4qSEnkb/GERFAJ-CONVENTO.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/q7qjbenjYPSjdN2KV4CDHC/gerfaj_convento_landing_01.png', 'https://cdn.magicpatterns.com/uploads/eX8cQNxhm4TFqqMbtQ4BM9/gerfaj_convento_landing_02.png', 'https://cdn.magicpatterns.com/uploads/wrRz4PmPJVF5XUBrMsTYJs/gerfaj_convento_landing_03.png']
}, {
  id: 'edificios',
  title: 'Edificios',
  image: 'https://cdn.magicpatterns.com/uploads/3Wdwck5yXpVYi1FuX8pW1Z/gerfaj_-_superior.png',
  gallery: ['https://cdn.magicpatterns.com/uploads/3o8VzmoUFsYJbP18TUDPwc/gerfaj_ch_landing.png', 'https://cdn.magicpatterns.com/uploads/x9uakRaLHQnXEc964EWPQy/gerfaj_ed_superior_landing.png', 'https://cdn.magicpatterns.com/uploads/x9LywTGaKVTHvdw42mDbyZ/gerfaj_jimfer_landing.png']
}, {
  id: 'bodegas',
  title: 'Bodegas',
  image: 'https://cdn.magicpatterns.com/uploads/trVYiPToySmS52td4KV34U/GERFAJ_-_BODEGAS.png',
  gallery: ['https://cdn.magicpatterns.com/uploads/fzX9YqxxyZXC6gdQ7WbnsZ/gerfaj_bodega_01.png', 'https://cdn.magicpatterns.com/uploads/n6wypPkQHqmjNExq4mAcyG/gerfaj_bodegas_02.png', 'https://cdn.magicpatterns.com/uploads/3QxEinSwzmRvWo69Z9mop6/gerfaj_bodegas_03.png']
}];
const empresaSubcategories = [{
  id: 'auditorios',
  title: 'Auditorios',
  image: 'https://cdn.magicpatterns.com/uploads/dKPfGKxLuczbw6aUqcyRiu/gerfaj_auditorio_crudo.jpg',
  gallery: []
}, {
  id: 'oficinas',
  title: 'Oficinas',
  image: 'https://cdn.magicpatterns.com/uploads/n54JtG5hFBrCUBYmurXNDo/gerfaj_turena_crudo.jpg',
  gallery: []
}, {
  id: 'recepciones',
  title: 'Recepciones',
  image: 'https://cdn.magicpatterns.com/uploads/6KEwAY755oDacGdTB8QWUy/gerfaj_sonesta.jpg',
  gallery: []
}];
const hogarSubcategories = [{
  id: 'reforma-residencial',
  title: 'Reforma',
  image: 'https://cdn.magicpatterns.com/uploads/kzwQoZUuNQShefJ8JK1WAF/gerfaj_conucos.png',
  gallery: ['https://cdn.magicpatterns.com/uploads/q8hsPfCvahLfzrEzSth4oa/gerfaj_auditorio_villa.png', 'https://cdn.magicpatterns.com/uploads/bg6eX3FJW3Q8RFdMgy9jte/gerfaj_enfermeria.png', 'https://cdn.magicpatterns.com/uploads/tzurTnTBFi84WRnueRsY3m/GERFAJ_RUITOQUE_LANDING.png']
}, {
  id: 'construccion-desde-cero',
  title: 'Construcción desde cero',
  image: 'https://cdn.magicpatterns.com/uploads/7L6jqj9Fk7y14cCuhjQ23Z/gerfaj_campo_hermoso.png',
  gallery: ['https://cdn.magicpatterns.com/uploads/87mGUaz1GP2YVWqMjseSSY/gerfaj_campo_hermoso_LANDING.png', 'https://cdn.magicpatterns.com/uploads/ga4eCCP2KPDQfamFgMSaFa/gerfaj_San_roque_02.jpg', 'https://cdn.magicpatterns.com/uploads/fq9aX6pabAMc7fJq9Hu93V/gerfaj_San_roque.png']
}];
const subcategoriesMap: Record<string, typeof granEscalaSubcategories> = {
  'gran-escala': granEscalaSubcategories,
  empresa: empresaSubcategories,
  hogar: hogarSubcategories
};
export function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState<Category>('gran-escala');
  const [activeSubcategory, setActiveSubcategory] = useState<string | null>(null);
  const handleCategoryChange = (catId: Category) => {
    setActiveCategory(catId);
    setActiveSubcategory(null);
  };
  const filteredProjects = projects.filter(p => p.category === activeCategory);
  const activeCatData = categories.find(c => c.id === activeCategory);
  const currentSubcategories = subcategoriesMap[activeCategory];
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20y%20quiero%20saber%20m%C3%A1s%20acerca%20de%20la%20l%C3%ADnea%20de%20proyectos%20para%20';
  return <section className="py-24 md:py-32 bg-gerfaj-dark" data-id="element-116">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-117">
        <div className="text-center mb-12" data-id="element-118">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-montserrat font-bold text-white mb-4" data-id="element-119">
            30 años de resultados que{' '}
            <span className="text-gerfaj-orange" data-id="element-120">puedes ver</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-base md:text-lg max-w-xl mx-auto" data-id="element-121">
            Aplicamos el mismo rigor profesional en cada detalle, sin importar
            la escala.
          </motion.p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-122">
          {categories.map(cat => <button key={cat.id} onClick={() => handleCategoryChange(cat.id)} className={`px-6 py-4 sm:py-3 rounded-2xl sm:rounded-full text-base font-medium transition-all duration-300 w-full sm:w-auto ${activeCategory === cat.id ? 'bg-gerfaj-blue text-white border border-gerfaj-blue shadow-lg' : 'bg-transparent text-gray-400 border border-gray-700 hover:border-gray-500 hover:text-white'}`} data-id="element-123">
              {cat.label}
            </button>)}
        </div>

        <motion.p key={activeCategory} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-gerfaj-orange font-medium text-base md:text-lg text-center mb-10 min-h-[3rem] flex items-center justify-center" data-id="element-124">
          {activeCatData?.desc}
        </motion.p>

        {currentSubcategories ? <div className="mb-12" data-id="element-125">
            <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${currentSubcategories.length === 5 ? 'xl:grid-cols-5' : 'xl:grid-cols-3'} gap-4`} data-id="element-126">
              {currentSubcategories.map((sub, index) => <Fragment key={sub.id} data-id="element-127">
                  <motion.div layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} onClick={() => {
              if (activeCategory === 'empresa') {
                document.getElementById('process-section')?.scrollIntoView({
                  behavior: 'smooth'
                });
              } else {
                setActiveSubcategory(activeSubcategory === sub.id ? null : sub.id);
              }
            }} className={`group relative aspect-video overflow-hidden rounded-2xl bg-gray-800 cursor-pointer border-2 transition-colors duration-300 ${activeSubcategory === sub.id ? 'border-gerfaj-orange' : 'border-transparent hover:border-gray-600'}`} data-id="element-128">
                    <img src={sub.image} alt={sub.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-85 group-hover:opacity-100" loading="lazy" decoding="async" width={1470} height={980} data-id="element-129" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-130"></div>
                    <div className="absolute bottom-0 left-0 p-4 w-full" data-id="element-131">
                      <h3 className="text-lg md:text-xl font-montserrat font-bold text-white drop-shadow-lg" data-id="element-132">
                        {sub.title}
                      </h3>
                      <div className={`h-1 bg-gerfaj-orange mt-2 rounded-full transition-all duration-300 ${activeSubcategory === sub.id ? 'w-12 opacity-100' : 'w-0 opacity-0 group-hover:w-8 group-hover:opacity-100'}`} data-id="element-133"></div>
                    </div>
                  </motion.div>

                  <AnimatePresence data-id="element-134">
                    {activeSubcategory === sub.id && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} transition={{
                duration: 0.4
              }} className={`overflow-hidden col-span-1 sm:col-span-2 lg:col-span-3 ${currentSubcategories.length === 5 ? 'xl:col-span-5' : 'xl:col-span-3'}`} data-id="element-135">
                        <div className="bg-white/5 border border-white/10 rounded-3xl p-5 md:p-8 relative mt-2" data-id="element-136">
                          <button onClick={e => {
                    e.stopPropagation();
                    setActiveSubcategory(null);
                  }} className="absolute top-4 right-4 p-2 bg-black/20 hover:bg-black/40 rounded-full text-gray-400 hover:text-white transition-colors z-10" data-id="element-137">
                            <X className="w-5 h-5" data-id="element-138" />
                          </button>

                          <h4 className="text-xl md:text-2xl font-montserrat font-bold text-white mb-5 flex items-center gap-3" data-id="element-139">
                            Proyectos de {sub.title}
                            <span className="h-px flex-1 bg-gradient-to-r from-white/10 to-transparent" data-id="element-140"></span>
                          </h4>

                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-141">
                            {sub.gallery.map((img, idx) => <motion.div key={idx} initial={{
                      opacity: 0,
                      y: 20
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} transition={{
                      delay: idx * 0.1
                    }} className="aspect-video rounded-2xl overflow-hidden bg-gray-800 relative" data-id="element-142">
                                <img src={img} alt={`Proyecto ${sub.title} ${idx + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width={1470} height={980} data-id="element-143" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" data-id="element-144"></div>
                              </motion.div>)}
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </Fragment>)}
            </div>
          </div> : <motion.div layout className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-145">
            <AnimatePresence mode="popLayout" data-id="element-146">
              {filteredProjects.map(project => <motion.div key={project.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4
          }} className="group relative aspect-video overflow-hidden rounded-2xl bg-gray-800" data-id="element-147">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" loading="lazy" decoding="async" width={1470} height={980} data-id="element-148" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-149"></div>
                  <div className="absolute bottom-0 left-0 p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-150">
                    <h3 className="text-2xl font-montserrat font-bold text-white drop-shadow-lg" data-id="element-151">
                      {project.title}
                    </h3>
                    <div className="w-12 h-1 bg-gerfaj-orange mt-4 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100" data-id="element-152"></div>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>}

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} id="portfolio-cta" className="flex justify-center" data-id="element-153">
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl cta-glow transition-colors duration-300 w-[90%] sm:w-auto min-h-[60px]" data-id="element-154">
            <MessageCircle className="w-6 h-6" data-id="element-155" />
            Quiero que mi proyecto se vea así
          </a>
        </motion.div>
      </div>
    </section>;
}